import { VIDEO_TILE_WIDTH } from '@/components/VideoTile';
import { useEffect, useState } from 'react';

const TILE_GAP = 24;

export function useVideoDisplayLimit(
    containerRef: React.MutableRefObject<HTMLDivElement | null>,
    itemCount: number,
    tileWidth = VIDEO_TILE_WIDTH
) {
    const [limit, setLimit] = useState<number>(1);

    const calculateLimit = () => {
        const width = containerRef.current?.offsetWidth || 0;
        const gap = Math.round((TILE_GAP * limit) / (limit + 1));
        const newLimit = Math.floor(width / (tileWidth + gap));

        const videosWidth = tileWidth * newLimit;
        const gapWidth = TILE_GAP * (newLimit - 1);
        const neededWidth = videosWidth + gapWidth;

        if (width < neededWidth) {
            setLimit(Math.max(newLimit - 1, 1));
        } else {
            setLimit(Math.max(newLimit, 1));
        }
    };

    useEffect(() => {
        window.addEventListener('resize', calculateLimit);

        return () => {
            window.removeEventListener('resize', calculateLimit);
        };
    }, []);

    useEffect(() => {
        calculateLimit();
    }, [itemCount]);

    return limit;
}
